import { render, staticRenderFns } from "./virtualCardConfig.vue?vue&type=template&id=69bddde4&"
import script from "./virtualCardConfig.vue?vue&type=script&lang=js&"
export * from "./virtualCardConfig.vue?vue&type=script&lang=js&"
import style0 from "./virtualCardConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports